import PageSizeDropdown from "../../../components/global-components/pageSizeDropDown";
import NewPaginationContainer from "../../../components/global-components/new-pagination";

interface Props {
  setPageSize: (size: number) => void;
  pageSizeOptions: number[];
  currentSize: number;
  setCurrentPage?: any;
  totalItems: any;
  totalPages: any;
  currentPage: any;
  pageSize: number;
}

export default function PaginationRow({
  setPageSize,
  pageSizeOptions,
  currentSize,
  setCurrentPage,
  totalItems,
  totalPages,
  currentPage,
  pageSize,
}: Props) {
  return (
    <div className='d-flex align-items-center justify-content-end gap-3'>
      <PageSizeDropdown
        setPageSize={setPageSize}
        pageSizeOptions={pageSizeOptions}
        currentSize={currentSize}
        setCurrentPage={setCurrentPage}
      />{' '}
      <NewPaginationContainer
        totalItems={totalItems}
        totalPages={totalPages}
        currentPage={currentPage}
        pageSize={pageSize}
        setCurrentPage={setCurrentPage}
      />
    </div>
  )
}

